import cookies from 'cookies-js'

const DESIRED_LANGUAGE = 'dojoDesiredLanguage'

const setLanguageCookie = (lang: string) => {
  cookies.expire(DESIRED_LANGUAGE)
  cookies.set(DESIRED_LANGUAGE, lang.toLowerCase(), {
    expires: Infinity
  })
}

export { setLanguageCookie, DESIRED_LANGUAGE }
